import { zfUtils } from "./zf_utils";
import { Swiper, Navigation, Pagination, A11y, Autoplay, EffectFade } from "./swiper-config";
export class zfccs {
    static getBreadcrumbWidth(that) {
        var width = 0;
        that.find(".zfcbn-breadcrumb-item").each(function () {
            width = width + $(this).width();
        });
        return width;
    }
    static checkBreadcrumb() {
        zfccs.breadcrumb.each(function () {
            var that = $(this);
            if (that.width() < zfccs.getBreadcrumbWidth(that)) {
                that.addClass("zfccs-breadcrumb-rtl");
            }
            else {
                that.removeClass("zfccs-breadcrumb-rtl");
            }
        });
    }
    static checkMobileCounterPosition(that, stage, nextPrevious) {
        if (nextPrevious == "previous") {
            if (zfccs.useSwiper &&
                that.find(".swiper-slide-active").prev().length != 0) {
                that
                    .find(".swiper-slide-active")
                    .prev()
                    .hasClass("zfccs-content-box-bottom")
                    ? stage.addClass("zfccs-corporate-stage-content-bottom")
                    : stage.removeClass("zfccs-corporate-stage-content-bottom");
            }
            else if (zfccs.useSwiper == false &&
                that.find(".slick-active").prev().length != 0) {
                that.find(".slick-active").prev().hasClass("zfccs-content-box-bottom")
                    ? stage.addClass("zfccs-corporate-stage-content-bottom")
                    : stage.removeClass("zfccs-corporate-stage-content-bottom");
            }
            else {
                that.find(".zfccs-stage-item:last").hasClass("zfccs-content-box-bottom")
                    ? stage.addClass("zfccs-corporate-stage-content-bottom")
                    : stage.removeClass("zfccs-corporate-stage-content-bottom");
            }
        }
        else {
            if (zfccs.useSwiper &&
                that.find(".swiper-slide-active").next().length != 0) {
                that
                    .find(".swiper-slide-active")
                    .next()
                    .hasClass("zfccs-content-box-bottom")
                    ? stage.addClass("zfccs-corporate-stage-content-bottom")
                    : stage.removeClass("zfccs-corporate-stage-content-bottom");
            }
            else if (zfccs.useSwiper == false &&
                that.find(".slick-active").next().length != 0) {
                that.find(".slick-active").next().hasClass("zfccs-content-box-bottom")
                    ? stage.addClass("zfccs-corporate-stage-content-bottom")
                    : stage.removeClass("zfccs-corporate-stage-content-bottom");
            }
            else {
                that
                    .find(".zfccs-stage-item:first")
                    .hasClass("zfccs-content-box-bottom")
                    ? stage.addClass("zfccs-corporate-stage-content-bottom")
                    : stage.removeClass("zfccs-corporate-stage-content-bottom");
            }
        }
    }
    static checkStageIncluded(array, key, value) {
        let exists = false;
        $.each(array, function (index, obj) {
            if (obj.hasOwnProperty(key) && obj[key] === value) {
                exists = true;
                return false;
            }
        });
        return exists;
    }
    static loadDelayedThumbnails(thumbnailNavigation, that, tries) {
        console.log(tries + " attempt to load stage thumbnail for video");
        var imgsLoaded = false;
        var thumbLength = thumbnailNavigation
            .find(".swiper-wrapper")
            .children().length;
        var thumbnailSwiper;
        var videoWrappers = that.find(".zfccs-video-wrapper");
        $(thumbnailNavigation)
            .find(".zfccs-thumbnail-img-delay-load")
            .each(function (index, item) {
            var image = $(item).find("img");
            if (image.length) {
                var video = $(videoWrappers[index]).find("video");
                if (video.length) {
                    var poster = $(video).attr("poster");
                    if (poster != undefined && poster.length) {
                        image.attr("src", poster);
                        $(item).removeClass("zfccs-thumbnail-img-delay-load");
                        imgsLoaded = true;
                    }
                }
            }
        });
        if (imgsLoaded == false &&
            $(thumbnailNavigation).find(".zfccs-thumbnail-img-delay-load").length >
                0 &&
            tries < 10) {
            setTimeout(function () {
                zfccs.loadDelayedThumbnails(thumbnailNavigation, that, tries + 1);
            }, 3000);
            return;
        }
        thumbnailNavigation.on("init", function () {
            $(this).find(".zfccs-stage-item").show();
        });
        if (zfccs.useSwiper) {
            thumbnailSwiper = new Swiper("#" +
                that
                    .parent()
                    .find(".zfccs-thumbnail-wrapper .zfccs-thumbnail-navigation")
                    .attr("id"), {
                modules: [Navigation, A11y],
                allowTouchMove: false,
                slidesPerView: 4,
                spaceBetween: 20,
                loop: thumbLength > 4,
                normalizeSlideIndex: true,
                preventClicks: false,
                preventClicksPropagation: false,
                breakpoints: {
                    1000: {
                        navigation: {
                            enabled: thumbLength > 4,
                            nextEl: ".thumbSlideNext .swiper-button-next",
                            prevEl: ".thumbSlidePrev .swiper-button-prev",
                        },
                    },
                    0: {
                        navigation: {
                            enabled: false,
                            nextEl: ".thumbSlideNext .swiper-button-next",
                            prevEl: ".thumbSlidePrev .swiper-button-prev",
                        },
                    },
                },
                a11y: {
                    enabled: true,
                    nextSlideMessage: "Next slide",
                    prevSlideMessage: "Previous slide",
                    paginationBulletMessage: "Jump to slide {{index}}",
                    slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                    slideRole: "group",
                    itemRoleDescriptionMessage: "slide",
                },
            });
        }
        else {
            thumbnailNavigation.slick({
                rows: 0,
                dots: false,
                slidesToShow: 4,
                infinite: thumbLength > 4,
                arrows: thumbLength > 4,
                prevArrow: '<span class="thumbSlidePrev slick-prev"></span>',
                nextArrow: '<span class="thumbSlideNext slick-next"></span>',
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            arrows: false,
                        },
                    },
                ],
            });
        }
        var thumbs = thumbnailNavigation.find(".zfccs-thumbnail-item");
        thumbnailNavigation.find(".zfccs-thumbnail-item").on("click", function () {
            if (zfccs.useSwiper) {
                var thatStage = $(this).closest(".zfccs-corporate-stage");
                var selectedSlideIndex = $(this).closest(".swiper-slide").index();
                $.each(zfccs.corporateStageSliders, function (index, x) {
                    if (thatStage.attr("id") == x.id && x.thumbnailSwiper != null) {
                        x.thumbnailSwiper.slideTo(selectedSlideIndex);
                        x.stageSwiper.slideTo(selectedSlideIndex);
                        thatStage
                            .find(".zfccs-thumbnail-wrapper .swiper-slide")
                            .eq(selectedSlideIndex)
                            .addClass("activeHighlight");
                    }
                });
            }
            else {
                var thatThumb = $(this);
                that.slick("slickGoTo", thatThumb.data("slickIndex"));
                thumbnailNavigation.slick("slickGoTo", thatThumb.data("slickIndex"));
            }
        });
        that.on("afterChange", function (event, slick, currentIndex, nextSlide) {
            thumbs.removeClass("activeHighlight");
            if (zfccs.useSwiper) {
                var thatStage = $(this).closest(".zfccs-corporate-stage");
                $.each(zfccs.corporateStageSliders, function (index, x) {
                    if (thatStage.attr("id") == x.id && x.thumbnailSwiper != null) {
                        thatStage
                            .find(".zfccs-thumbnail-wrapper .swiper-slide-active")
                            .addClass("activeHighlight");
                    }
                });
            }
            else {
                thumbnailNavigation
                    .find('[data-slick-index="' +
                    currentIndex +
                    '"], [data-slick-index="' +
                    (currentIndex + thumbs.length) +
                    '"]')
                    .addClass("activeHighlight");
            }
        });
        if (zfccs.useSwiper == false) {
            var currentSlideIndex = thumbnailNavigation
                .find(".slick-current")
                .data("slick-index");
            thumbnailNavigation
                .find('[data-slick-index="' +
                currentSlideIndex +
                '"], [data-slick-index="' +
                (currentSlideIndex + thumbLength) +
                '"]')
                .addClass("activeHighlight");
        }
        else {
            return thumbnailSwiper;
        }
    }
    static initStage(stage) {
        try {
            zfccs.useSwiper = stage.find(".zfcss-item-wrapper").hasClass("swiper");
            stage.find("img[data-src-3-2]").each(function () {
                if (!$(this).hasClass("zfccs-mobile-imag") &&
                    stage
                        .closest(".zfcsw-wrapper > .zfcsw-wrapper-content")
                        .hasClass("zfc-wrapper-content")) {
                    $(this).attr("src", $(this).data("src-3-2"));
                }
            });
            stage.find("img[data-src]").each(function () {
                $(this).attr("src", $(this).data("src"));
            });
            if (zfccs.useSwiper) {
                if (stage.find("> .zfcss-item-wrapper > .swiper-wrapper").length == 0 &&
                    stage.find("> .zfcss-item-wrapper > .zfccs-stage-item").length <= 1) {
                    stage.addClass("zfccs-has-single-item");
                }
            }
            else {
                if (stage.find("> .zfcss-item-wrapper > .zfccs-stage-item").length <= 1) {
                    stage.addClass("zfccs-has-single-item");
                }
            }
            stage.find("> .zfccs-corporate-stage-slider").each(function () {
                var that = $(this);
                var videoWrappers = that.find("> .zfccs-stage-item > .zfccs-video-wrapper");
                if (videoWrappers.length > 0)
                    $(this).addClass("zfccs-slider-with-video");
                var thumbnailNavigation = that
                    .parent()
                    .find("> .zfccs-thumbnail-wrapper .zfccs-thumbnail-navigation");
                var dotNav = that
                    .parent()
                    .find("> .zfcsw-wrapper .zfccs-dot-navigation");
                var thumbLength = thumbnailNavigation.children().length;
                var outerSlider = !that.closest(".zfccs-stage-wrapper").length;
                var stageItemCount = that.find(".zfccs-stage-item").length;
                if (outerSlider == false) {
                    var topStage = that
                        .closest(".zfccs-corporate-stage")
                        .parent()
                        .closest(".zfccs-corporate-stage");
                    topStage
                        .find("> .zfcss-item-wrapper")
                        .addClass("zfccs-top-stage-background");
                    topStage
                        .find("> .zfcsw-wrapper")
                        .addClass("zfccs-top-stage-background");
                    topStage
                        .find("> .zfccs-progress")
                        .addClass("zfccs-top-stage-progress");
                    if (that.find(".zfccs-content-box-wrapper").length > 0) {
                        that
                            .parent()
                            .find("> .zfccs-thumbnail-wrapper")
                            .addClass("zfccs-thumbnail-under-content");
                        topStage
                            .find("> .zfcsw-wrapper .zfc-wrapper-content")
                            .addClass("zfccs-top-stage-dot-nav");
                    }
                    else {
                        that
                            .parent()
                            .closest(".zfcss-item-wrapper")
                            .addClass("zfccs-no-box");
                    }
                }
                if (zfccs.useSwiper) {
                    if (!that.hasClass("swiper-initialized")) {
                        const swiper = new Swiper("#" + that.attr("id"), {
                            modules: [Navigation, Pagination, A11y, Autoplay, EffectFade],
                            allowTouchMove: that.hasClass("zfccs-thumbnail-included")
                                ? true
                                : false,
                            effect: that.parent().data("fade") ? "fade" : "swipe",
                            slidesPerView: 1,
                            spaceBetween: 40,
                            loop: thumbnailNavigation.length ? false : true,
                            normalizeSlideIndex: true,
                            preventClicks: false,
                            preventClicksPropagation: false,
                            autoplay: {
                                delay: that.parent().data("autoplay") == true
                                    ? that.parent().data("speed")
                                    : 10000,
                                pauseOnMouseEnter: true,
                                disableOnInteraction: false,
                            },
                            fadeEffect: {
                                crossFade: that.parent().data("fade") ? true : false,
                            },
                            breakpoints: {
                                720: {
                                    navigation: {
                                        enabled: outerSlider
                                            ? !that.hasClass("zfccs-thumbnail-included")
                                                ? stageItemCount > 1
                                                : false
                                            : false,
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                    pagination: {
                                        enabled: true,
                                        el: ".swiper-pagination",
                                        type: "bullets",
                                        clickable: true,
                                        renderBullet: function (index, className) {
                                            return ('<button type="button" class="' +
                                                className +
                                                '" aria-label="Go to slide ' +
                                                (index + 1) +
                                                '"></button>');
                                        },
                                    },
                                },
                                0: {
                                    allowTouchMove: that.hasClass("zfccs-thumbnail-included")
                                        ? true
                                        : false,
                                    navigation: {
                                        enabled: outerSlider ? stageItemCount > 1 : false,
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                    pagination: {
                                        enabled: that.find(".zfccs-stage-item").length > 1,
                                        el: ".swiper-pagination",
                                        type: "bullets",
                                        clickable: true,
                                        renderBullet: function (index, className) {
                                            return ('<button type="button" class="' +
                                                className +
                                                '" aria-label="Go to slide ' +
                                                (index + 1) +
                                                '"></button>');
                                        },
                                    },
                                },
                            },
                            a11y: {
                                enabled: true,
                                nextSlideMessage: "Next slide",
                                prevSlideMessage: "Previous slide",
                                paginationBulletMessage: "Jump to slide {{index}}",
                                slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                                slideRole: "group",
                                itemRoleDescriptionMessage: "slide",
                            },
                        });
                        swiper.on("init", function () {
                            if (that.find(".slick-active").hasClass("zfccs-content-box-bottom")) {
                                stage.addClass("zfccs-corporate-stage-content-bottom");
                            }
                            else {
                                stage.removeClass("zfccs-corporate-stage-content-bottom");
                            }
                            $(this).find(".zfccs-stage-item").show();
                        });
                        swiper.on("beforeSlideChangeStart", function () {
                            if (swiper.realIndex <
                                that.find(".swiper_slide_next").data("swiper_slide_index") ||
                                (that.find(".zfccs-stage-item").length - 1 ==
                                    swiper.realIndex &&
                                    that.find(".swiper_slide_next").data("swiper_slide_index") ==
                                        0)) {
                                zfccs.checkMobileCounterPosition(that, stage, "next");
                            }
                            else {
                                zfccs.checkMobileCounterPosition(that, stage, "previous");
                            }
                        });
                        swiper.on("slideChangeTransitionEnd", function () {
                            if (that.parent().data("autoplay") == true) {
                                that
                                    .parent()
                                    .find(".zfccs-ring-circle")
                                    .removeClass("zfccs-ring-circle-autoplay");
                                setTimeout(function () {
                                    that
                                        .parent()
                                        .find(".zfccs-ring-circle")
                                        .addClass("zfccs-ring-circle-autoplay");
                                }, 0.5);
                            }
                            zfUtils.sliderCircleProgress(stage, ".zfccs-ring-circle", ".zfccs-progress-text", zfccs.useSwiper);
                        });
                        if (that.parent().data("autoplay") == true) {
                            that.find(".zfccs-stage-item > .zfccs-image-wrapper").on({
                                mouseenter: function () {
                                    if (swiper.autoplay.timeLeft != that.parent().data("speed")) {
                                        swiper.autoplay.stop();
                                        swiper.autoplay.timeLeft = that.parent().data("speed");
                                    }
                                },
                                mouseleave: function () {
                                    swiper.autoplay.start();
                                },
                            });
                        }
                        else {
                            swiper.autoplay.running = false;
                        }
                        if (thumbnailNavigation.length) {
                            var thumbnail = zfccs.loadDelayedThumbnails(thumbnailNavigation, that, 1);
                            swiper.on("slideChangeTransitionEnd", function () {
                                var thatStage = $(this.hostEl).closest(".zfccs-corporate-stage");
                                var selectedSlideIndex = $(this.hostEl)
                                    .find(".swiper-slide.swiper-slide-active")
                                    .index();
                                $.each(zfccs.corporateStageSliders, function (index, x) {
                                    if (thatStage.attr("id") == x.id &&
                                        x.thumbnailSwiper != null) {
                                        thatStage
                                            .find(".zfccs-thumbnail-wrapper .swiper-slide")
                                            .removeClass("activeHighlight");
                                        thatStage
                                            .find(".zfccs-thumbnail-wrapper .swiper-slide")
                                            .eq(selectedSlideIndex)
                                            .addClass("activeHighlight");
                                    }
                                });
                            });
                        }
                        if (zfccs.checkStageIncluded(zfccs.corporateStageSliders, "id", stage.attr("id")) == false) {
                            if (thumbnailNavigation.length) {
                                zfccs.corporateStageSliders.push({
                                    id: stage.attr("id"),
                                    stageSwiper: swiper,
                                    thumbnailSwiper: thumbnail,
                                });
                                $.each(zfccs.corporateStageSliders, function (index, x) {
                                    if (that.attr("id") == x.id && x.thumbnailSwiper != null) {
                                        x.thumbnailSwiper.control = x.stageSwiper;
                                        x.stageSwiper.control = x.thumbnailSwiper;
                                    }
                                });
                            }
                            else {
                                zfccs.corporateStageSliders.push({
                                    id: stage.attr("id"),
                                    stageSwiper: swiper,
                                });
                            }
                        }
                    }
                }
                else {
                    var slickData = {
                        rows: 0,
                        autoplay: that.parent().data("autoplay"),
                        autoplaySpeed: that.parent().data("speed"),
                        arrows: outerSlider ? true : false,
                        pauseOnFocus: false,
                        pauseOnHover: true,
                        fade: that.parent().data("fade"),
                        speed: 500,
                        dots: outerSlider
                            ? that.find("> .zfccs-stage-item").length > 1
                            : false,
                        dotsClass: "not-default custom-dots",
                        appendDots: dotNav,
                        swipe: outerSlider
                            ? !that.find(".zfccs-stage-item > .zfccs-stage-wrapper").length
                                ? true
                                : false
                            : false,
                        swipeToSlide: outerSlider
                            ? !that.find(".zfccs-stage-item > .zfccs-stage-wrapper").length
                                ? true
                                : false
                            : false,
                        responsive: [
                            {
                                breakpoint: 720,
                                settings: {
                                    arrows: outerSlider ? true : false,
                                    dots: outerSlider
                                        ? that.find("> .zfccs-stage-item").length > 1
                                        : false,
                                },
                            },
                        ],
                    };
                    if (thumbLength > 4) {
                        slickData.appendDots = dotNav;
                        slickData.asNavFor = thumbnailNavigation;
                    }
                    that.on("init", function () {
                        if (that.find(".slick-active").hasClass("zfccs-content-box-bottom")) {
                            stage.addClass("zfccs-corporate-stage-content-bottom");
                        }
                        else {
                            stage.removeClass("zfccs-corporate-stage-content-bottom");
                        }
                        $(this).find(".zfccs-stage-item").show();
                    });
                    that.slick(slickData);
                }
                if (that.hasClass("zfccs-slider-with-video")) {
                    if (zfccs.useSwiper) {
                        that.find(".swiper-button-prev").on("click", function () {
                            that.find("video-js.vjs-playing").each(function () {
                                $(this).find("video").get(0).pause();
                            });
                            if (!that
                                .find(".zfccs-stage-item.slick-active video-js")
                                .hasClass("vjs-playing")) {
                                that
                                    .find(".zfccs-stage-item.slick-active video-js video")
                                    .get(0).play();
                            }
                        });
                        that.find(".swiper-button-next").on("click", function () {
                            that.find("video-js.vjs-playing").each(function () {
                                $(this).find("video").get(0).pause();
                            });
                            if (!that
                                .find(".zfccs-stage-item.slick-active video-js")
                                .hasClass("vjs-playing")) {
                                that
                                    .find(".zfccs-stage-item.slick-active video-js video")
                                    .get(0).play();
                            }
                        });
                    }
                    else {
                        that.find(".slick-arrow").on("click", function () {
                            that.find("video-js.vjs-playing").each(function () {
                                $(this).find("video").get(0).pause();
                            });
                            if (!that
                                .find(".zfccs-stage-item.slick-active video-js")
                                .hasClass("vjs-playing")) {
                                that
                                    .find(".zfccs-stage-item.slick-active video-js video")
                                    .get(0).play();
                            }
                        });
                    }
                }
                if (zfccs.useSwiper == false) {
                    that.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                        if (currentSlide < nextSlide ||
                            (that.find(".zfccs-stage-item").length - 1 == currentSlide &&
                                nextSlide == 0)) {
                            zfccs.checkMobileCounterPosition(that, stage, "next");
                        }
                        else {
                            zfccs.checkMobileCounterPosition(that, stage, "previous");
                        }
                    });
                    that.on("afterChange", function () {
                        if (that.parent().data("autoplay") == true) {
                            that
                                .parent()
                                .find(".zfccs-ring-circle")
                                .removeClass("zfccs-ring-circle-autoplay");
                            setTimeout(function () {
                                that
                                    .parent()
                                    .find(".zfccs-ring-circle")
                                    .addClass("zfccs-ring-circle-autoplay");
                            }, 0.5);
                        }
                        zfUtils.sliderCircleProgress(stage, ".zfccs-ring-circle", ".zfccs-progress-text", zfccs.useSwiper);
                    });
                    if (thumbnailNavigation.length) {
                        zfccs.loadDelayedThumbnails(thumbnailNavigation, that, 1);
                    }
                }
                that.on("swipe", function (event, slick, direction) {
                    if (that.find(".zfcacc-item.zfcacc-toggled").length > 0 &&
                        $(window).width() < 720)
                        that.find(".zfcacc-item.zfcacc-toggled")[0].slideClose(function () { });
                });
            });
            zfccs.checkBreadcrumb();
            stage.append('<div class="zfccs-progress"><svg class="zfccs-ring"><circle class="zfccs-ring-circle" r="19" cx="23" cy="23"></circle></svg><div class="zfccs-progress-text zfcui-prometo-medium"></div></div>');
            if (stage.data("autoplay") == true) {
                stage
                    .find("> .zfccs-progress .zfccs-ring-circle")
                    .addClass("zfccs-ring-circle-autoplay");
            }
            else {
                stage
                    .find("> .zfccs-progress .zfccs-ring-circle")
                    .addClass("zfccs-ring-circle-slide-count");
            }
            if (stage.find("> .zfccs-thumbnail-wrapper .zfccs-thumbnail-navigation")
                .length) {
                stage.addClass("zfccs-mobile-progress");
            }
            zfUtils.sliderCircleProgress(stage, ".zfccs-ring-circle", ".zfccs-progress-text", zfccs.useSwiper);
            if (stage.find("> .zfcsw-wrapper .zfccs-dot-navigation").length) {
                stage
                    .find("> .zfcsw-wrapper .zfccs-dot-navigation")
                    .addClass("zfccs-dot-navigation-hidden");
            }
            if (stage.parent().hasClass("zfc-wrapper-content")) {
                stage.find("> .zfccs-progress").addClass("zfccs-progress-adjusted");
            }
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfccs.initStage() " + err.message);
        }
    }
}
zfccs.corporateStageSliders = [];
zfccs.breadcrumbResizeKey = null;
try {
    zfUtils.onReady(function () {
        zfccs.breadcrumb = $(".zfccs-breadcrumb-wrapper");
        $(".zfccs-corporate-stage").each(function () {
            zfUtils.loadOnScroll($(this), "delayZFCCSLoad", zfccs.initStage, $("*[data-region]").length ? 4 : 2);
        });
        if (zfccs.breadcrumbResizeKey !== null) {
            zfUtils.offResize(zfccs.breadcrumbResizeKey);
        }
        zfccs.breadcrumbResizeKey = zfUtils.onResize(zfccs.checkBreadcrumb);
    });
}
catch (err) {
    console.log("Initalization failed: zfccs.initStage() " + err.message);
}
